import { eventBusKey } from '@/models/symbols/Eventbus';
import mitt, { Emitter, EventType } from 'mitt';
import { Plugin } from 'vue';

const emitter = mitt();

declare module 'vue' {
    export interface ComponentCustomProperties {
        $eventBus: Emitter<Record<EventType, unknown>>
    }
}

const eventbusPlugin: Plugin = {
    install: (app, options) => {
        app.config.globalProperties.$eventBus = emitter;
        app.provide(eventBusKey, emitter);
    }
}

export default eventbusPlugin;